<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="外销合同编号：" prop="orderCode">
        <order-drop v-model="dataForm.orderCode" clearable></order-drop>
      </el-form-item>
      <el-form-item label="工厂名称：" prop="factoryName">
        <el-input size="mini" v-model="dataForm.factoryName" clearable></el-input>
      </el-form-item>
      <el-form-item prop="productName" label="品名：">
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：">
        <el-input
            v-model="dataForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="请输入颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：">
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="请输入规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr1" label="幅宽：">
        <el-input
            v-model="dataForm.productAttr1"
            size="mini"
            clearable
            type="text"
            placeholder="请输入幅宽"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr2" label="克重：">
        <el-input
            v-model="dataForm.productAttr2"
            size="mini"
            clearable
            type="text"
            placeholder="请输入克重"
        ></el-input>
      </el-form-item>
      <el-form-item prop="businessMan" label="业务担当：">
        <el-input
            v-model="dataForm.businessMan"
            size="mini"
            clearable
            type="text"
            placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item prop="overRate" label="冗余量：">
        <div style="display: flex;align-items: center;">
          <el-input
              v-model="dataForm.overRate" style="width: 100px;"
              size="mini"
              clearable
              type="text">
            <template #suffix>%</template>
          </el-input>
          <el-tooltip effect="dark" content="冗余量是指剩余物料与入库物料的比值(百分比)，用于过滤小额差值的问题"
                      placement="right">
            <el-icon class="el-icon-warning" style="font-size: 18px;cursor: pointer;margin-left: 5px;"></el-icon>
          </el-tooltip>
        </div>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox v-model="dataForm.orderStatus" label="已结束合同" :true-label="200" false-label=""></el-checkbox>
      </el-form-item>
      <el-form-item label="">
        <el-button @click="reload()" size="mini" type="primary">{{ $t('query') }}</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-button @click="remoteExportExcel()" size="mini" type="primary">{{ $t('export') }}</el-button>
      </el-form-item>
    </el-form>
    <SweetTable ref="table" url="/erp/store/limit/material/page" api-version="v2" :query-form="dataForm"
                :before-table-binding="beforeTableBinding" :row-style="rowStyleHandler"
                :summariesColumn="['totalAmount','useCount','limitCount','productSendCount']">
      <el-table-column
          prop="orderCode"
          label="外销合同号"
          header-align="center"
          align="center" width="160"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="businessManName"
          label="业务担当"
          header-align="center"
          align="left" width="160"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="factoryName"
          label="工厂名称"
          header-align="center"
          align="center" width="160"
          :show-overflow-tooltip="true" :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column
          prop="materialInfo.name"
          label="品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      >
        <template #default="{row}">
          <ProductRowCard :product="row.materialInfo"></ProductRowCard>
        </template>
      </el-table-column>
      <el-table-column prop="receiveCount" label="收货数量" header-align="center" align="center" width="100">
        <template #default="{row}">
          <el-button type="text" @click="showMaterialReceiveList(row)">{{ row.receiveCount }}</el-button>
        </template>
      </el-table-column>
      <!--      <el-table-column-->
      <!--          prop="price"-->
      <!--          label="开票单价"-->
      <!--          header-align="center"-->
      <!--          align="center" width="100"-->
      <!--      >-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--          label="金额"-->
      <!--          header-align="center"-->
      <!--          align="center"-->
      <!--          prop="totalAmount" width="100"-->
      <!--      >-->
      <!--      </el-table-column>-->
      <el-table-column
          prop="useCount"
          label="用料数量"
          header-align="center"
          align="center" width="100"
      >
        <template #default="{row}">
          <el-button type="text" @click="showMaterialUseList(row)">{{ row.useCount }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
          prop="receiptPrice"
          label="开票单价"
          header-align="center"
          align="center" width="100"
      >
      </el-table-column>
      <el-table-column
          prop="limitCount"
          label="库存数量"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true" width="100"
      ></el-table-column>
      <el-table-column
          prop="remark"
          :show-overflow-tooltip="true"
          label="备注"
          header-align="center"
          align="center" width="80" fixed="right"
      >
      </el-table-column>
      <el-table-column
          label="操作"
          header-align="center"
          align="center" width="80" fixed="right"
      >
        <template #default="{row}">
          <el-button type="text" size="mini" @click="showRemarkDialog(row)">备注</el-button>
        </template>
      </el-table-column>
    </SweetTable>
    <MaterialUseList ref="MaterialUseList"></MaterialUseList>
    <MaterialReceiveList ref="MaterialReceiveList"></MaterialReceiveList>
    <RemarkDialog ref="remarkDialog" bisKey="物料库存"></RemarkDialog>
  </div>
</template>

<script>
import RemarkDialog from '@/views/modules/common/remark-dialog.vue'
import SweetTable from '@/mixins/SweetTable'
import BigNumber from 'bignumber.js'
import MaterialUseList from '@/views/modules/settle/report/material-use-list.vue'
import MaterialReceiveList from '@/views/modules/settle/report/material-receive-list.vue'
import ProductRowCard from '@/components/ProductRowCard.vue'

export default {
  name: 'material-store',
  mixins: [SweetTable],
  components: { ProductRowCard, MaterialUseList, MaterialReceiveList, RemarkDialog },
  data () {
    return {
      dataForm: {
        orderCode: '',
        factoryName: '',
        productName: '',
        productColor: '',
        productSize: '',
        productAttr1: '',
        productAttr2: '',
        businessMan: '',
        orderStatus: '',
        overRate: 1
      }
    }
  },
  methods: {
    remoteExportExcel () {
      
       this.$export('/erp/store/limit/material/export', this.dataForm,'','v2')
    },
    showRemarkDialog (row) {
      let bisId = row.orderId + '-' + row.factoryId + '-' + row.materialId
      this.$refs.remarkDialog.init(bisId)
    },
    rowStyleHandler ({ row, rowIndex }) {
      let rowStyle = {}
      if (row.isWarning === 1) {
        rowStyle = {
          color: 'red'
        }
      }
      return rowStyle
    },
    showMaterialReceiveList (row) {
      this.$refs.MaterialReceiveList.materialInfo = row.materialInfo
      this.$refs.MaterialReceiveList.init(row.companyId, row.materialId, row.orderId)
    },
    showMaterialUseList (row) {
      this.$refs.MaterialUseList.materialInfo = row.materialInfo
      this.$refs.MaterialUseList.init(row.companyId, row.materialId, row.orderId)
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        if (!row.receiveCount) {
          row.receiveCount = 0
        }
        if(row.receiptCount&&row.receiptCount>0){
          row.receiptPrice = new BigNumber(row.receiptAmount).div(row.receiptCount)
        }else{
          row.receiptPrice = 0
        }
        row.limitCount = this.$c.prettyNum(new BigNumber(row.receiveCount).minus(row.useCount).toFixed(5))
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.count-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
</style>
